import React, {useContext} from 'react'
import { Typography, FormControlLabel, Radio } from '@mui/material'
import { Trans } from 'react-i18next'
import { ComplaintState } from '../../../contexts/types'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type DamageFractureOptionsProps = {
    complaint: ComplaintState
}

const DamageFractureOptions: React.FC<DamageFractureOptionsProps> = ({
    complaint,
}) => {
    const eventOccurrence = complaint.complaintType.location
    const wasPatientInvolved = complaint.generalComplaint.wasPatientInvolved
    const { t, tns } = useContext(OrgCustomizationContext)

    return (
        <>
            {/* Damage / Fracture */}
            <Typography
                variant='body1'
                color='secondary.contrastText'
                sx={{ pt: 2 }}
            >
                <Trans i18nKey={tns('cti_complaint_damage')}>
                    -
                    <Typography component='span' sx={{ color: 'primary.main' }}>
                        -
                    </Typography>
                    -
                </Trans>
            </Typography>
            {wasPatientInvolved === 'YES' &&
                (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                    eventOccurrence === '5_CLINIC_AFTER_PROCEDURE') && (
                    <FormControlLabel
                        value='PART_FRACTURED'
                        control={<Radio />}
                        label={t('cti_option_part_fractured') as string}
                    />
                )}
            <FormControlLabel
                value='DEFORMED'
                control={<Radio />}
                label={t('cti_option_deformed') as string}
            />
            {['CLINICAL_INSTRUMENT', 'LAB_INSTRUMENT_LAB_SCREW'].includes(complaint.generalComplaint.productType || '') && <FormControlLabel
                value='PREMATURE_WEAR'
                control={<Radio/>}
                label={t('cti_option_premature_wear') as string}
            />}
        </>
    )
}

export default DamageFractureOptions
